module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ways) ? _c('table', {
    staticClass: "el-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.ways), function(w) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(w.ways))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(w.sharers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(w.percent) + "%")])])
  })], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Ways")]), _vm._v(" "), _c('th', [_vm._v("Sharers")]), _vm._v(" "), _c('th', [_vm._v("Percent")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56ca3893"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sharers/WaysSummaryReport.vue
// module id = 1574
// module chunks = 0